// Dawn ships 300ms here. That delay exists so typing into the quantity field
// doesn't fire a request per keystroke, but it also gates the +/- buttons,
// where it reads as dead time before anything happens. 150ms still coalesces
// fast repeated clicks while feeling immediate.
const ON_CHANGE_DEBOUNCE_TIMER = 150;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};